// Roles.utils.ts

import { PermissionSectionData } from "../components/PermissionList";

interface ApiPermission {
  id: number;
  code: string;
}

interface ApiPermissionGroup {
  id: number;
  name: string;
  permissions: ApiPermission[];
}

export function mapApiPermissionsToSections(
  apiGroups: ApiPermissionGroup[],
  checkedIds: Set<number> = new Set()
): PermissionSectionData[] {
  return apiGroups.map((group) => ({
    key: String(group.id),
    label: group.name,
    groups: [
      {
        items: group.permissions.map((perm) => ({
          key: String(perm.id),
          label: perm.code,
          checked: checkedIds.has(perm.id),
        })),
      },
    ],
  }));
}